import { MouseEvent, ReactNode } from 'react';

import Typography from '~/shared/components/Typography';

export interface SelectableOptionCardProps {
  inputId: string;
  checked: boolean;
  label: string;
  description?: string;
  children: ReactNode;
  onSelect?: () => void;
}

export default function SelectableOptionCard({
  inputId,
  label,
  description,
  children,
  onSelect,
}: SelectableOptionCardProps) {
  const handleClick = (event: MouseEvent<HTMLElement>) => {
    if (!onSelect) return;

    const target = event.target as HTMLElement;
    if (target.closest('button, input, [role="checkbox"], [role="radio"]')) return;

    onSelect();
  };

  const content = (
    <>
      <div className="flex my-auto h-fit">
        {children}

      </div>
      <div className="font-family-inter">
        <Typography className="" variant="p3-reg" fontWeight={600}>
          {label}
        </Typography>
        {description && (
          <Typography variant="caption" className="">
            {description}
          </Typography>
        )}
      </div>
    </>
  );

  if (onSelect) {
    return (
      <div
        className="flex gap-2 cursor-pointer transition-colors"
        onClick={handleClick}
      >
        {content}
      </div>
    );
  }

  return (
    <label
      htmlFor={inputId}
      className="flex gap-2 cursor-pointer transition-colors"
    >
      {content}
    </label>
  );
}